export default __webpack_public_path__ + "71ba9a6123e1b4cb90cd687d56c713ac.png";